import Phylotree, { placenodes } from "./phylotree.js";
import { phylotree as phylotreev1 } from "phylotree";
export default Phylotree;
export { placenodes, phylotreev1 };